import _ from 'underscore'

import SentryReporter from './SentryReporter'

const ProtocolTest = new RegExp(/(http(s?))\:\/\//gi)

/**
 * Adds "https://" to links that need it.
 *
 * - //google.com
 * - http://google.com
 * - google.com
 */
function fixAnchorURL (anchor) {
    let replacementAnchor =
        (typeof anchor === 'string') ?
            _.clone(anchor) : false

    if (replacementAnchor.indexOf('mailto:') >= 0) {
        return replacementAnchor
    }

    if (replacementAnchor.substr(0, 2) == '//') {
        replacementAnchor = 'https:' + replacementAnchor
    } else if (replacementAnchor.indexOf('http://') > -1) {
        replacementAnchor = 'https://' + (
            replacementAnchor.substr(
                'http://'.length,
                replacementAnchor.length
            )
        )
    } else if (replacementAnchor.indexOf('https://') === -1) {
        replacementAnchor = 'https://' + replacementAnchor
    }

    return replacementAnchor
}


/**
 * NOTE: Only used for HTML Strings generated by the Quill RTE
 *
 * If the HTML string given has anchor elements then we need to
 * check if they have a protocl in them or add one if not (always add https://)
 */
export default {
    parseAndRepaceAnchors (sourceHtmlString) {
        let didError = false
        let editedHtmlString = _.clone(sourceHtmlString)

        try {
            const parser = new DOMParser()

            let parsed = parser.parseFromString(
                editedHtmlString, 'text/html'
            )

            let anchors = parsed.getElementsByTagName('a')

            if (anchors.length) {
                for (let k = 0; k < anchors.length; k++) {
                    let anchor = anchors[k]
                    let link = fixAnchorURL(
                        anchor.getAttribute('href')
                    )

                    if (link !== false) {
                        let replacement = parsed.createElement('a')
                        replacement.setAttribute('href', link)
                        if (link.indexOf('mailto:') === -1) {
                            replacement.setAttribute('target', '_blank')
                            replacement.setAttribute('rel', 'noopener noreferrer')
                        }
                        replacement.innerHTML = anchor.innerHTML

                        // Replace the anchor in the original string
                        parsed.getElementsByTagName('a')[k]
                            .parentNode
                            .replaceChild(
                                replacement, anchor
                            )
                    }
                }
            }

            // editedHtmlString = parsed.documentElement.outerHTML
            editedHtmlString = parsed.body.innerHTML
        } catch (error) {
            console.warn(error)
            didError = true
            SentryReporter.send(
                'HtmlAnchorReplacer', 'error', {
                    error: error,
                    sourceHtmlString: sourceHtmlString
                }
            )
        }

        return (!didError) ? editedHtmlString : _.clone(sourceHtmlString)
    }
}
